
<div [className]="'not_Found'"> 
  <div>
    <div>
      <div>
        <table width="100%" border="0" cellpadding="0" cellspacing="0" >
          <tbody>
            <tr>
              <td  align="center" valign="top">
                
              </td>
            </tr>
            <tr>
              <td  align="center" valign="top">
                <p>{{'Common.ResourceNotfound' |translate}}</p>
              </td>
            </tr>
            <tr>
              <td  align="center" valign="top">
                <div >
                  <button class="btn btn-info" (click)="gotoHome()"> {{'Common.BackToHome' |translate}}</button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</div>


